export type GetServiceOrderByRentalOrderIdApiResponse = {
  serviceCaseId?: string | null | undefined;
  serviceOrderId?: string | null | undefined;
  serviceJobId?: string | null | undefined;
};

export type GetServiceOrderByRentalOrderIdApiArg = {rentalOrderId: string};
